import { render } from "./TarotCardScrollContainer.vue?vue&type=template&id=4c621c03&scoped=true"
import script from "./TarotCardScrollContainer.vue?vue&type=script&lang=js"
export * from "./TarotCardScrollContainer.vue?vue&type=script&lang=js"

import "./TarotCardScrollContainer.vue?vue&type=style&index=0&id=4c621c03&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c621c03"]])

export default __exports__